import { i18n } from "@/shared/i18n/i18n";
import { createApp } from "vue";
import { addVueError } from "@datadog/browser-rum-vue";
import App from "./App.vue";
import WatsonComponentsCompatible from "@/components/watson/WatsonComponentsCompatible";
import { storeOriginalConsoleLog, overrideConsoleLog } from "@/utils/consoleOverride";

// Initialize global console.log override for environment-aware logging
storeOriginalConsoleLog();
overrideConsoleLog();

// Datadog browser observability is initialized inside AIAssistant.vue, gated
// by the `NOA_browser_rum_enabled` GrowthBook flag. Default = off, no SDK
// init at all. See `src/utils/observability/initWithGrowthBookGate.ts`.

const app = createApp(App);
app.config.errorHandler = addVueError;
app.use(i18n);
app.use(WatsonComponentsCompatible);

app.mount("#app");
